import { render, staticRenderFns } from "./OpeningBalancesPG.vue?vue&type=template&id=8527da3e&"
import script from "./OpeningBalancesPG.vue?vue&type=script&lang=js&"
export * from "./OpeningBalancesPG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports